import theme from "../../theme";

export const style = {
  SECTION: {
    background: theme.foregroundColor,
  },
  SECTION_INNER: {
    margin: "0 auto",
    padding: 100,
    mobile: {
      desktop: {
        padding: 100,
      },
      smartphone: {
        padding: 15,
      },
    },
  },
  HEADLINE: {
    fontFamily: theme.fontFamily,
    fontSize: "26pt",
    // fontWeight: "bold" as "bold",
    textAlign: "left",
    padding: 20,
    mobile: {
      desktop: {
        fontSize: "26pt",
      },
      smartphone: {
        fontSize: "16pt",
      },
    },
  },
  TEXT: {
    fontFamily: theme.fontFamily,
    fontSize: "13pt",
    textAlign: "left",
    lineHeight: "18pt",
    padding: 40,
  },
};
